/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MonitorIcon = ({
  className,
  style,
  color = '#3a50f3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M13.1549 0.763916H0.84517C0.379149 0.763916 0 1.14307 0 1.60909V10.1081C0 10.5741 0.379149 10.9532 0.84517 10.9532H5.06322V11.5682C5.06322 12.1319 4.60456 12.5906 4.04081 12.5906H3.11121C2.93298 12.5906 2.78847 12.7351 2.78847 12.9133C2.78847 13.0916 2.93298 13.2361 3.11121 13.2361H10.8888C11.067 13.2361 11.2115 13.0916 11.2115 12.9133C11.2115 12.7351 11.067 12.5906 10.8888 12.5906H9.95913C9.39538 12.5906 8.93672 12.1319 8.93672 11.5682V10.9533H13.1548C13.6208 10.9533 14 10.5741 14 10.1081V1.60909C14 1.14307 13.6209 0.763916 13.1549 0.763916ZM5.3572 12.5907C5.57721 12.308 5.70876 11.9533 5.70876 11.5682V10.9533H8.2913V11.5682C8.2913 11.9533 8.42285 12.3081 8.64286 12.5907H5.3572ZM13.3545 10.1081C13.3545 10.2182 13.265 10.3078 13.1548 10.3078H0.84517C0.735056 10.3078 0.64545 10.2182 0.64545 10.1081V8.41187H13.3545V10.1081ZM13.3545 7.76636H0.645478V1.60909C0.645478 1.49897 0.735056 1.40937 0.845197 1.40937H13.1548C13.2649 1.40937 13.3546 1.49894 13.3546 1.60909V7.76636H13.3545Z"
        fill={color}
      />
      <path
        d="M7.00013 9.70821C7.19249 9.70821 7.34843 9.55227 7.34843 9.3599C7.34843 9.16754 7.19249 9.0116 7.00013 9.0116C6.80777 9.0116 6.65182 9.16754 6.65182 9.3599C6.65182 9.55227 6.80777 9.70821 7.00013 9.70821Z"
        fill={color}
      />
      <path
        d="M7.55339 2.98734C7.42733 2.86132 7.22305 2.86132 7.09694 2.98734L4.81608 5.2682C4.69005 5.39422 4.69005 5.59859 4.81608 5.72465C4.87913 5.78767 4.96168 5.81917 5.04432 5.81917C5.12695 5.81917 5.2095 5.78767 5.27253 5.72465L7.55339 3.44379C7.67941 3.31777 7.67941 3.1134 7.55339 2.98734Z"
        fill={color}
      />
      <path
        d="M8.90529 4.30912C8.77929 4.1831 8.575 4.1831 8.44886 4.3091L7.54023 5.21768C7.4142 5.34373 7.4142 5.5481 7.54023 5.67413C7.60326 5.73715 7.68583 5.76865 7.76844 5.76865C7.85102 5.76865 7.93362 5.73715 7.99665 5.67413L8.90529 4.76555C9.03131 4.63952 9.03131 4.43515 8.90529 4.30912Z"
        fill={color}
      />
    </svg>
  );
};
